
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kisisel-veriler",
      function () {
        return require("private-next-pages/kisisel-veriler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kisisel-veriler"])
      });
    }
  